import React, { ReactNode } from 'react';
import LoginLayout from 'features/shared/Login/layout';
import styled from 'styled-components';
import { Space } from '@gr-monorepo/common/ui';

const Code = styled.div`
  color: #517acd;
  font-size: 80px;
  font-weight: 700;
  line-height: 48px;
  text-align: center;
`;

const Title = styled.div`
  color: #517acd;
  font-size: 32px;
  font-weight: 700;
  line-height: 44px;
  text-align: center;
`;

const Text = styled.div`
  font-size: 14px;
  text-align: center;
  line-height: 20px;
`;

const ErrorPageTemplate = (props: { code: string; title: string; text?: ReactNode }) => {
  return (
    <LoginLayout>
      <Space size={104} axis="vertical" />
      <Code>{props.code}</Code>
      <Space size={32} axis="vertical" />
      <Title>{props.title}</Title>
      <Space size={24} axis="vertical" />
      {props.text && <Text>{props.text}</Text>}
    </LoginLayout>
  );
};

export default ErrorPageTemplate;
